/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@hooks/useAuthContext';
import { ConfigProvider } from 'antd';
import { StytchProvider } from '@stytch/react';
import { StytchUIClient } from '@stytch/vanilla-js';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { checkBeforeRender } from './utils/before-render';
import './index.css';
import { STYTCH_PUBLIC_TOKEN } from './constants';

const stytch = new StytchUIClient(STYTCH_PUBLIC_TOKEN);

const root = ReactDOM.createRoot(document.getElementById('root'));
checkBeforeRender();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#645AFF',
            controlHeight: 36,
            borderRadius: 4,
          },
        }}
      >
        <AuthProvider>
          <StytchProvider stytch={stytch}>
            <App />
          </StytchProvider>
        </AuthProvider>
      </ConfigProvider>

    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
